// extracted by mini-css-extract-plugin
export default {"pagination":"PaginationComp_pagination__Z48oh","pageBtn":"PaginationComp_pageBtn__O5lnx","active":"PaginationComp_active__MVxwW","ellipsis":"PaginationComp_ellipsis__py3Ld"};